import Model from "../Model";

export default class Invoice extends Model {
    get url() {
        return '/api/invoices';
    }
}
